
export default () => {

  const fileInputWrapper = document.querySelector('.wpcf7 .file-input');
  const fileInput = document.querySelector('.wpcf7 .file-input input[type="file"]');
  const inputFileName = document.querySelector('.wpcf7 .input-file-name');
  const inputButtonRemove = document.querySelector('.wpcf7 .input-button-remove');

  function changeFileNameLength(fileName) {
    if (fileName.length > 25) {
      var extension = fileName.substr(fileName.lastIndexOf('.'));
      fileName = fileName.substr(0, 22) + '...' + extension;
    }
    return fileName;
  }

  fileInput?.addEventListener('change', function (event) {
    if (fileInput.files.length > 0) {
      let fileName = fileInput.files[0].name;
      inputFileName.textContent = changeFileNameLength(fileName);
      fileInputWrapper.classList.add('file-selected');
    } else {
      inputFileName.textContent = '';
      fileInputWrapper.classList.remove('file-selected');
    }
  });

  inputButtonRemove?.addEventListener('click', function () {
    fileInput.value = ''; 
    inputFileName.textContent = '';
    fileInputWrapper.classList.remove('file-selected');
  });
}
